export default "__VITE_ASSET__XI9LzEj9__"